import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { DownloadCloudIcon, FourRectanglesIcon, PersonIcon, WalletIcon } from './common/Icons';
import logoTipSvgUrl from 'src/webportal/theme/images/logotip.svg';

export class SideBar extends React.Component {
    render() {
        return (
            <div className="main__navigation">
                <nav className="nav navbar-toggleable-sm d-flex p-0 h-100">
                    <a href="https://lucidlink.com/" target="_blank" className="logo align-self-start">
                        <img src={logoTipSvgUrl} alt="Lucid Link logo" />
                    </a>
                    <button
                        className="navbar-toggler navbar-toggler-right"
                        type="button"
                        data-toggle="collapse"
                        data-target="#mainNav"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon">
                            <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1">
                                <path d="M0,9.5 L0,6.98 L20.04,6.98 L20.04,9.5 L0,9.5 Z M20.04,0 L20.04,2.52 L0,2.52 L0,0 L20.04,0 Z" />
                            </svg>
                        </span>
                    </button>
                    <div
                        id="mainNav"
                        className="navbar-collapse collapse d-md-flex flex-md-column align-self-md-stretch justify-content-md-between w-100"
                    >
                        <div>
                            <NavLink
                                to={'/dashboard'}
                                exact={false}
                                className="nav-link"
                                activeClassName="active"
                            >
                                <FourRectanglesIcon width="20px" height="20px" />
                                <span>Dashboard</span>
                            </NavLink>
                            <NavLink
                                to={'/billing'}
                                className="nav-link"
                                activeClassName="active"
                            >
                                <WalletIcon width="20px" height="20px" />
                                <span>Billing</span>
                            </NavLink>
                            <NavLink
                                to={'/profile'}
                                className="nav-link"
                                activeClassName="active"
                            >
                                <PersonIcon width="20px" height="20px" />
                                <span>Profile</span>
                            </NavLink>
                        </div>
                        <div>
                            <a className="nav-link" href="https://lucidlink.com/download-lucidlink-classic" target="_blank">
                                <DownloadCloudIcon width="20px" height="20px" />
                                <span>Download<br />Client</span>
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/SideBar.tsx